import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrganizationGameCategoryItem} from "../../../interfaces/organization-game-category-item";
import {GameCategoryLevel} from "../../../interfaces/game-category-level";
import {GamesService} from "../../../services/games.service";
import {GameCategoriesSelectorMode} from "../../../ts-types/game-categories-selector-mode";
import {EGame} from "../../../enums/game";
import {DataService} from "../../../services/data.service";

@Component({
  selector: 'brt-game-category-preview',
  templateUrl: './game-category-preview.component.html',
  styleUrls: ['./game-category-preview.component.scss']
})
export class GameCategoryPreviewComponent implements OnInit {

  @Output('select-changed') onSelectChanged = new EventEmitter<number>();
  @Input('data') set setData(val: OrganizationGameCategoryItem) {
    this.data = val;

    // this.data.multiplier = this.currentMultiplier;

    this.totalPoints = 0;
    this.gamePointsMapping = new Map<string, number>();

    this.data.progress.forEach((el) => {
      this.gamePointsMapping.set(this.gamesService.getGameNameById(el.gameId), el.points);
    });
  }

  @Input('mode') mode: GameCategoriesSelectorMode = "teacher";
  @Input('gameId') set setGameId(gameId: EGame){
      this.gameId = gameId;
      this.setCategoryLevels();
  }

  @Input('selected') set setSelected(val: boolean) {
    this.isSelected = val;
  }
  @Input('isGlobalTraining') isGlobalTraining = false;

  isSelected = false;

  totalPoints: number = 0;

  gameMilestones = {
    total: 12,
    current: 0
  }

  gamePointsMapping = new Map<string, number>();

  data!: OrganizationGameCategoryItem;
  gameId!: EGame;
  categoryLevels: GameCategoryLevel[] = [];
  maxPoints = 0; // set in function setCategoryLevels
  tooltipLabel = "";

  constructor(
    private gamesService: GamesService,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
    if(this.mode === "teacher") {
      this.tooltipLabel = "Gesamt";
      this.totalPoints = 0;

      this.data.progress.forEach((el) => {
        this.totalPoints+= el.points;
      });
    } else if(this.mode === "student") {
      this.tooltipLabel = "Highscore";
      this.data.progress.forEach((el) => {
        if(el.gameId === this.gameId) {
          this.totalPoints = el.points;

          this.gameMilestones = {
            total: 12,
            current: el.round
          }
        }
      });

      // this.calculateMilestones(this.gameId, this.totalPoints);
      this.setCategoryLevelActive();
    }
  }

  calculateMilestones(gameId: EGame, currentPoints: number): void {
    // Change logic here for all games by gameId and possible game object
    const totalMilestones = 12;

    const oneMilestoneStep = 1200 / totalMilestones;
    let currentMilestone = Math.floor(currentPoints / oneMilestoneStep);

    this.gameMilestones = {
      total: totalMilestones,
      current: currentMilestone
    };

  }

  onItemClicked() {
    this.onSelectChanged.emit(this.data.categoryData.id);
  }

  setCategoryLevels(){
      if(this.gameId === EGame.QUIZ){
          this.maxPoints = 100;

          this.categoryLevels = [
          {
              active: false,
              label: "LV1",
              multiplier: 1.0,
              points: 100,
              step: 1
          },
          {
              active: false,
              label: "LV2",
              multiplier: 0.9,
              points: 90,
              step: 2
          },
          {
              active: false,
              label: "LV3",
              multiplier: 0.7,
              points: 70,
              step: 3
          },
          {
              active: false,
              label: "LV4",
              multiplier: 0.4,
              points: 40,
              step: 4
          }
          ];
      }

      if(this.gameId === EGame.CLICK_THE_PIC){
          this.maxPoints = 60;

          this.categoryLevels = [
          {
              active: false,
              label: "LV1",
              multiplier: 1.0,
              points: 60,
              step: 1
          },
          {
              active: false,
              label: "LV2",
              multiplier: 0.8,
              points: 48,
              step: 2
          },
          {
              active: false,
              label: "LV3",
              multiplier: 0.6,
              points: 36,
              step: 3
          },
          {
              active: false,
              label: "LV4",
              multiplier: 0.2,
              points: 12,
              step: 4
          }
          ];
      }
  }

  setCategoryLevelActive() {
      this.categoryLevels.forEach(level => {
          if(level.multiplier === this.data.multiplier){
              level.active = true;
              this.maxPoints = level.points;
          }
      });
  }
}
